
import { createReducer, on } from '@ngrx/store';
import { loadCorporateData, loadCorporateDataSuccess, loadCorporateDataFailure } from '../actions/corporates.actions';

export interface State {
  corporateData: any[];
  loading: boolean;
  error: string | null;
}

export const initialState: State = {
  corporateData: [],
  loading: false,
  error: null,
};

export const corporateReducer = createReducer(
  initialState,
  on(loadCorporateData, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(loadCorporateDataSuccess, (state, { corporateData }) => ({
    ...state,
    loading: false,
    corporateData,
  })),
  on(loadCorporateDataFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  }))
);
